import React from 'react';
import { Reveal } from '../Reveal';
import { Button } from '../Button';
import { TrajectoryChart } from '../chart/TrajectoryChart';
import { useLayout } from '../../contexts/LayoutContext';
type CloseScreenProps = {
  onExplore: () => void;
  onDetails: () => void;
};
export function CloseScreen({
  onExplore,
  onDetails
}: CloseScreenProps) {
  const {
    compact,
    wide
  } = useLayout();
  const headline = <Reveal data-id="element-68" data-mp="1skb7wz0fq7s7">
      <h2 className={`max-w-md font-display font-light tracking-[-0.03em] text-ink ${compact ? 'text-[2.1rem] leading-[1.08]' : 'text-5xl leading-[1.05]'}`} data-id="element-69" data-mp="1sjrw801dofmm">
        New mechanism. New Phase&nbsp;3 evidence.
      </h2>
    </Reveal>;
  const question = <Reveal delay={0.25} data-id="element-70" data-mp="1xcukptrasyvy">
      <p className={`max-w-md font-display font-light leading-snug text-muted ${compact ? 'text-xl' : 'text-2xl'}`} data-id="element-71" data-mp="1xcl06lp0vjxn">
        What could this mean for patients who are still losing lung function?
      </p>
    </Reveal>;
  const actions = <Reveal delay={0.4} data-id="element-72" data-mp="1b6i87zmj17ky">
      <div className={compact ? 'flex flex-col gap-3' : 'flex flex-wrap items-center gap-3'} data-id="element-73" data-mp="1b71qxik04001">
        <Button fullWidth={compact} onClick={onExplore} data-id="element-74" data-mp="1g64lua69opua">
          Explore FIBRONEER-IPF
        </Button>
        <Button fullWidth={compact} variant="secondary" showArrow={false} onClick={onDetails} data-id="element-75" data-mp="1l3d5kf72d1xn">
          View study details
        </Button>
      </div>
    </Reveal>;
  const chart = <Reveal delay={0.1} data-id="element-76" data-mp="1u5mbssvau958">
      <TrajectoryChart animated={false} showGapLabel data-id="element-77" data-mp="1u4b9kxhi59g8" />
    </Reveal>;
  if (wide) {
    return <div className="grid min-h-full grid-cols-[minmax(0,5fr)_minmax(0,7fr)] items-center gap-16 py-10" data-id="element-78" data-mp="1z2cqpcvdayp2">
        <div data-id="element-79" data-mp="23vfnruzcsqa0">
          {headline}
          <div className="mt-8" data-id="element-80" data-mp="28th78h0oyrm0">{question}</div>
          <div className="mt-10" data-id="element-81" data-mp="28t7hmujk6mgu">{actions}</div>
        </div>
        {chart}
      </div>;
  }
  return <div className={`flex min-h-full flex-col ${compact ? 'py-6' : 'justify-center py-10'}`} data-id="element-82" data-mp="2duohcmqb42vu">
      {headline}
      <div className={compact ? 'mt-6' : 'mt-10'} data-id="element-83" data-mp="2hschc46uwlul">{chart}</div>
      <div className={compact ? 'mt-6' : 'mt-10'} data-id="element-84" data-mp="iqgoheh8lplq">{question}</div>
      <div className={compact ? 'mt-auto pt-8' : 'mt-10'} data-id="element-85" data-mp="dqubn65bmbdg">{actions}</div>
    </div>;
}